<template>
  <div>
    <vx-card title="Dados Gerais">
      <form-empresa :subjectPermission="subjectPermission"></form-empresa>
    </vx-card>
  </div>
</template>

<script>
import FormEmpresa from "./../../forms/FormEmpresa";

export default {
  data() {
    return {
      subjectPermission: "Empresa",
    };
  },
  methods: {},
  components: {
    FormEmpresa,
  },
};
</script>
